import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"user",
    list_id:"ueval_card_list",
    x_column_list_arr:[
      // {"key":"row_view_manage","name":"관리","width":"80","is_show":"1"},
      {"key":"a_user_name","name":"이름","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'a_date',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      
      "s_stu_state":"now",
      "s_user_name_like":"",
      "s_school_name_like":"",
      "s_class_name_like":"",
      "s_class_seq":"",
      "s_stu_grade":"",

      "s_addon_eval_s_subject_like":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  xColumnArr.select_arr["a_sort_detail"]=[
    {"value":"attend","text":"등원"},
    {"value":"late","text":"등원(지각)"},
    {"value":"absent","text":"결석"},
    {"value":"out","text":"하원"},
  ];

  return xColumnArr;
};

export default getXcolumnJson;